import {
  Icon,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { Link } from 'gatsby'
import React from 'react'
import AllLinks from './alllinks'
import './layout.css'

const useStyles = makeStyles(theme => ({
  titleFont: {
    fontFamily: 'Volkhov',
  },
}))

const PublicationsLinks = props => {
  const classes = useStyles()
  return (
    <div>
      <Typography variant="h5" className={classes.titleFont}>
        In This Section
      </Typography>
      <List>
        {AllLinks.publications.map((v, k) => (
          <ListItem button key={k} component={Link} to={v.link}>
            <Icon style={{ marginRight: 24, color: '#1B3263' }}>{v.icon}</Icon>
            <ListItemText
              primary={v.name}
              style={{ color: '#1B3263' }}
              className={classes.titleFont}
            />
          </ListItem>
        ))}
      </List>
    </div>
  )
}

export default PublicationsLinks
